import React, { SelectHTMLAttributes } from 'react';
import { SelectStyled, ErrorMessage } from './styles';

export interface Props extends SelectHTMLAttributes<HTMLSelectElement> {
  name: string;
  children: React.ReactNode;
  errorMessage?: string;
}

const Select = ({ name, children, errorMessage, ...rest }: Props) => {
  return (
    <>
      <SelectStyled errorMessage={errorMessage} id={name} name={name} {...rest}>
        {children}
      </SelectStyled>
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  );
};

export default Select;
